import { c as _c } from "react/compiler-runtime";
import NavBar from "@/components/NavBar/NavBar";
import s from "./HomePage.module.scss";
import StatusActive from "@/assets/icons/StatusActive";
import Link from "next/link";
import SkillsCard from "@/components/SkillsCard/Skills";
import ProjectsCard from "@/components/Projecs/ProjectsCard";
import WhatsappIcon from "@/assets/icons/WhatsappIcon";
import MailIcon from "@/assets/icons/MailIcon";
import Footer from "@/components/Footer/Footer";
import SectionLink from "@/components/SectionLink/SectionLink";
import ArrowIcon from "@/assets/icons/ArrowIcon";
import ReactIcon from "@/assets/icons/dev-icons/ReactIcon";
import FigmaIcon from "@/assets/icons/dev-icons/FigmaIcon";
import GitIcon from "@/assets/icons/dev-icons/GitIcon";
export default function HomeContent() {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NavBar page="home" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={s.titleWrapper}><h1>Lyan Brito</h1><h1>Web Developer</h1></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <main id="home" className={s.textWrapper}>{t1}<div className={s.ATWcontainer}><StatusActive /><span>Available To Work</span></div><p>{"Hi! I'm a developer passionate in UI/UX & Web Development. Throughout my journey, I gained experience in several areas. Take a look on my works."}</p></main>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SectionLink isLink={true} isBlank={false} title="About me" description="Here some special skills that i learned in my trajectory" linkLabel="My Stacks" linkRef="/AboutMePage" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SkillsCard link="https://www.google.com/url?sa=t&source=web&rct=j&opi=89978449&url=https://react.dev/&ved=2ahUKEwicsbe4g_iQAxWEqpUCHbi9JngQFnoECBYQAQ&usg=AOvVaw1tEjYYiD7LQlxO53dgjTHV" cardPage="home" type="react" title="React" icon={<ReactIcon />} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SkillsCard link="https://www.figma.com/pt-br/design/" cardPage="home" type="figma" title="Design UI/UX" icon={<FigmaIcon />} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section id="about-me" className={s.sectionContainer}>{t3}<div className={s.cardWrapper}>{t4}{t5}<SkillsCard link="https://git-scm.com/book/ms/v2/Getting-Started-About-Version-Control" cardPage="home" type="git" title="Git Versioning" icon={<GitIcon />} /></div></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SectionLink isLink={true} title="Projects" description="As a student, I tracked my journey in development producting some projects" linkLabel="View More" linkRef="/ProjectsPage" isBlank={false} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <section id="projects" className={s.sectionContainer}>{t7}<div className={s.cardWrapper}><ProjectsCard page="home" project="luna" /><ProjectsCard page="home" project="spring-project" /></div></section>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <h2>Let's talk for something special!</h2>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Link className={s.socialLink} href="mailto:lyanbrito613@gmail.com"><MailIcon />lyanbrito613@gmail.com</Link>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link className={s.socialLink} href="tel:+5511986581730"><WhatsappIcon />(11) 9 8658-1730</Link>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className={s.homeContainer}>{t0}{t2}{t6}{t8}<section id="contacts" className={s.sectionContainer}>{t9}<div className={s.socialWrapepr}>{t10}{t11}<Link className={s.button} href="/ContactsPage">More Contact Info <ArrowIcon /></Link></div></section><Footer page="home" /></div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  return t12;
}